<template>
  <b-modal
    id="import-modal"
    v-model="isShowModal"
    title="Import file"
    size="xl"
    @hide="handleClose"
  >
    <div class="modal-body">
      <!-- Radio buttons -->
      <div class="radio-group mb-2">
        <b-form-radio v-model="selectedType" name="type" value="PAYMENT" class="mr-3 btn">
          Thanh toán
        </b-form-radio>
        <b-form-radio v-model="selectedType" class="btn" name="type" value="RECOUPMENT">
          Truy thu
        </b-form-radio>
      </div>

      <!-- File upload buttons -->
      <div class="d-flex mb-1 ml-2">
        <b-button variant="outline-primary" class="mr-2" size="sm" @click="handleDownloadTemplate">
          <i class="bx bx-download"></i>
          {{ loadingDownTemplatefile ? 'Đang tải...' : 'Tải file mẫu' }}
        </b-button>

        <b-button
          size="sm"
          variant="outline-success"
          @click="$refs.fileInput.click()"
          :disabled="loadingUpFile"
        >
          <i class="bx bxs-file-plus"></i>
          {{ loadingUpFile ? 'Đang tải...' : 'Tải lên file' }}
        </b-button>
        <input
          type="file"
          ref="fileInput"
          @change="handleFileChange"
          accept=".xlsx,.xls,.csv"
          class="d-none"
        />
        <div class="mt-1 ml-3" v-if="isUpload">
          <b-badge variant="success" class="mr-2">Thành công: {{ successCount }}</b-badge>
          <b-badge variant="danger">Thất bại: {{ failedCount }}</b-badge>
        </div>
      </div>

      <!-- Tabs -->
      <div class="mb-3">
        <b-tabs v-model="activeTab">
          <template #tabs-end>
            <div style="display: flex; justify-content: space-between; width: calc(100% - 205px)">
              <input
                v-model="txtSearch"
                type="text"
                class="input-search d-inline-block"
                style="
                  width: 200px;
                  height: 25px;
                  text-indent: 5px;
                  margin-top: 10px;
                  border: none;
                  border-left: 1px solid #638cea;
                  margin-left: 10px;
                "
                placeholder="🔎 Từ khóa"
              />
              <b-button
                v-if="activeTab === 1"
                variant="outline-danger"
                size="sm"
                @click="dowloadFileError"
                style="margin-top: 10px; margin-right: 10px; width: 150px"
              >
                <i class="bx bx-download"></i>
                {{ loadingDownError ? 'Đang tải...' : 'Tải các bản ghi thất bại' }}
              </b-button>
            </div>
          </template>
          <b-tab title="Thành công">
            <template v-slot:title> Thành công </template>
            <div>
              <div class="mt-2 mb-1">
                Tổng: <b class="text-primary">{{ successCount }}</b>
              </div>
              <b-table
                :items="filteredSuccessItems"
                :fields="fields"
                striped
                hover
                :busy.sync="loadingUpFile"
                sticky-header
                responsive
                :fixed="true"
                :bordered="true"
              >
                <template #cell(index)="data">
                  <span>{{ data.index + 1 }}</span>
                </template>
              </b-table>
            </div>
          </b-tab>

          <b-tab title="Thất bại">
            <template v-slot:title> Thất bại </template>
            <div>
              <div class="mt-2 mb-1">
                Tổng: <b class="text-primary">{{ failedCount }}</b>
              </div>
              <b-table
                :items="filteredFailedItems"
                :fields="filedsError"
                striped
                hover
                :busy.sync="loadingUpFile"
                sticky-header
                responsive
                :fixed="true"
                :bordered="true"
              >
                <template #cell(index)="data">
                  <span>{{ data.index + 1 }}</span>
                </template>
                <template #cell(cancelledTime)="data">
                  <span>{{ data.item.cancelledTime | formatTime }}</span>
                </template>
                <template #cell(confirmTime)="data">
                  <span>{{ data.item.confirmTime | formatTime }}</span>
                </template>
              </b-table>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <template #modal-footer>
      <b-button variant="light" @click="handleClose"> Hủy </b-button>
      <b-button
        :disabled="loadingComfirm || activeTab === 1 || successCount === 0"
        variant="primary"
        @click="handleConfirm"
      >
        {{ loadingComfirm ? 'Đang tải...' : 'Xác nhận' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import {
    UploadFile,
    downloadTemplateExcel,
    downloadErrorExcel,
    comfirmUpload,
  } from '@/services/tingbox-ctv'
  import { showMess } from '@/config/utils'

  export default {
    name: 'ImportModal',
    props: ['onLoad'],
    data() {
      return {
        isShowModal: false,
        loadingComfirm: false,
        loadingUpFile: false,
        loadingDownError: false,
        isUpload: false,
        selectedType: 'PAYMENT',
        txtSearch: '',
        activeTab: 0,
        importedData: [],
        loadingDownTemplatefile: false,
        fields: [
          {
            key: 'index',
            label: 'STT',
            tdClass: 'text-center',
            thClass: 'text-center',
          },
          { key: 'userSellName', label: 'Người bán thiết bị' },
          { key: 'userReceiveName', label: 'Người thụ hưởng' },
          { key: 'typeName', label: 'Loại thanh toán' },
          { key: 'serial', label: 'Serial' },
          {
            key: 'merchantEmail',
            label: 'Merchant',
            thStyle: { 'min-width': '200px', width: '200px' },
          },
          { key: 'registrationTypeName', label: 'Loại ĐKKD' },
          { key: 'contractCode', label: 'Hợp đồng' },
          { key: 'statusName', label: 'Trạng thái' },
          {
            key: 'amount',
            label: 'Số tiền hoa hồng',
            formatter: value => value?.toLocaleString('vi-VN') + ' đ',
          },
          {
            key: 'createdTime',
            label: 'Ngày tạo',
            thStyle: { 'min-width': '200px', width: '200px' },
            formatter: value => (value ? new Date(value).toLocaleDateString('vi-VN') : ''),
          },
          {
            key: 'confirmTime',
            label: 'Ngày thanh toán/truy thu',
            thStyle: { 'min-width': '200px', width: '200px' },
            // formatter: (value) =>
            //   value ? new Date(value).toLocaleDateString('vi-VN') : ''
          },
          {
            key: 'cancelledTime',
            label: 'Ngày hủy',
            thStyle: { 'min-width': '200px', width: '200px' },
            // formatter: (value) =>
            //   value ? new Date(value).toLocaleDateString('vi-VN') : ''
          },
          {
            key: 'note',
            label: 'Ghi chú',
            tdClass: 'text-wrap',
            thClass: 'text-center',
            thStyle: { 'min-width': '200px', width: '200px' },
          },
          { key: 'action', label: 'Hành động' },
          {
            key: 'reason',
            label: 'Lý do',
            tdClass: 'text-wrap',
            thClass: 'text-center',
            thStyle: { 'min-width': '200px', width: '200px' },
          },
        ],
      }
    },

    computed: {
      // get name type
      typeName() {
        if (this.selectedType === 'PAYMENT') {
          return 'thanh-toan'
        } else {
          return 'truy-thu'
        }
      },
      filedsError() {
        return [
          ...(this.fields || []),
          {
            key: 'message',
            label: 'Nguyên nhân gây lỗi',
            tdClass: 'text-wrap',
            thClass: 'text-center',
            thStyle: { 'min-width': '200px', width: '200px' },
          },
        ]
      },
      // Filter items thành công
      filteredSuccessItems() {
        const searchTerm = this.txtSearch.toLowerCase().trim()
        if (!searchTerm) return this.successItems

        return this.successItems.filter(item => {
          return (
            item.userSellName?.toLowerCase().includes(searchTerm) ||
            item.userReceiveName?.toLowerCase().includes(searchTerm) ||
            item.serial?.toLowerCase().includes(searchTerm) ||
            item.merchantEmail?.toLowerCase().includes(searchTerm) ||
            item.contractCode?.toLowerCase().includes(searchTerm) ||
            item.statusName?.toLowerCase().includes(searchTerm) ||
            item.typeName?.toLowerCase().includes(searchTerm)
          )
        })
      },

      // Filter items thất bại
      filteredFailedItems() {
        const searchTerm = this.txtSearch.toLowerCase().trim()
        if (!searchTerm) return this.failedItems

        return this.failedItems.filter(item => {
          return (
            item.userSellName?.toLowerCase().includes(searchTerm) ||
            item.userReceiveName?.toLowerCase().includes(searchTerm) ||
            item.serial?.toLowerCase().includes(searchTerm) ||
            item.merchantEmail?.toLowerCase().includes(searchTerm) ||
            item.contractCode?.toLowerCase().includes(searchTerm) ||
            item.statusName?.toLowerCase().includes(searchTerm) ||
            item.typeName?.toLowerCase().includes(searchTerm)
          )
        })
      },
      //
      successItems() {
        return this.importedData?.listCorrect || []
      },
      failedItems() {
        return this.importedData?.listError || []
      },

      successCount() {
        return this.successItems?.length || 0
      },
      failedCount() {
        return this.failedItems?.length || 0
      },
    },
    filters: {
      // lấy ngày, giờ
      formatTime(text) {
        if (!text) return
        return text?.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1')
      },
    },
    methods: {
      // show modal
      show() {
        this.isShowModal = true
      },

      resetFileInput() {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = ''
        }
      },

      // đóng modal
      handleClose() {
        this.isShowModal = false
        this.resetData()
        this.isUpload = false
      },
      // cài đặt lại trạng thái state
      resetData() {
        this.selectedType = 'PAYMENT'
        this.activeTab = 0
        this.importedData = []
      },

      // tải file error
      async dowloadFileError() {
        this.loadingDownError = true
        const list = this.failedItems || []
        try {
          const res = await downloadErrorExcel(list)
          res &&
            (() => {
              const href = URL.createObjectURL(res)
              // download QR
              const link = document.createElement('a')
              link.href = href
              link.setAttribute('download', `download-error-${this.typeName}-ctv.xlsx`)
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              URL.revokeObjectURL(href)
            })()
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingDownError = false
        }
      },
      // tải excel mẫu
      async handleDownloadTemplate() {
        this.loadingDownTemplatefile = true
        try {
          const res = await downloadTemplateExcel({ type: this.selectedType })
          res &&
            (() => {
              const href = URL.createObjectURL(res)
              // download QR
              const link = document.createElement('a')
              link.href = href
              link.setAttribute('download', `download-template-${this.typeName}-ctv.xlsx`)
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              URL.revokeObjectURL(href)
            })()
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingDownTemplatefile = false
        }
      },

      // tải file excel lên
      handleFileChange(event) {
        const file = event.target.files[0]
        if (file) {
          // TODO: Implement file processing logic
          this.processFile(file)
        }
      },

      // tiến trình tải
      async processFile(file) {
        this.loadingUpFile = true
        try {
          // Example processing
          const formData = new FormData()
          formData.append('file', file)
          formData.append('type', this.selectedType)
          const res = await UploadFile(formData)

          this.importedData = res.data || []
          showMess(
            this,
            'Đã tải lên',
            `Tải lên thành công: ${res.data?.listCorrect?.length || 0} |
          Tải lên thất bại: ${res.data?.listError?.length || 0}`,
            'success',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingUpFile = false
          this.isUpload = true
          this.resetFileInput()
        }
      },

      // xac nhận

      async handleConfirm() {
        this.loadingComfirm = true
        try {
          const res = await comfirmUpload({
            type: this.selectedType,
            list: this.successItems || [],
          })
          if (res.code === 1000) {
            showMess(
              this,
              'Success',
              res.message || 'Xác nhận thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
            this.$emit('onLoad')
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Lỗi xác nhận',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (error) {
          showMess(this, 'Error', error.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingComfirm = false
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .modal-body {
    padding-top: 0;
    max-height: 75vh;
    height: 75vh;
    overflow-y: auto;
    .radio-group {
      display: flex;
      justify-items: center;
    }
  }
  :deep(.modal-xl) {
    max-width: 1400px;
  }
</style>
